<script>
import { Doughnut } from 'vue-chartjs'
export default {
	extends: Doughnut,
	props: ['data'],
	
    methods: {
        getTotalWorkspaces() {
                this.datacollection.labels = ["Available", "Occupied"];
                this.datacollection.datasets[0].data[0] = this.data.count_available;
                this.datacollection.datasets[0].data[1] = this.data.count_occupied;
                this.renderChart(this.datacollection, {responsive: true,maintainAspectRatio: false, legend: {position: 'left'}});
        }

    },
    computed: {

    },
    mixins: [Doughnut],
    data(){

        return {
            is_loading: false,
            datacollection: {
                labels: ["orange", "Red", "blue"],
                datasets: [
                  {
                    label: "Data One",
                    backgroundColor: ["#034A81", "#F1631B"],
                    data: [1, 10]
                  }
                ],
            },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    },
                    
                }
            
        }

    },
    mounted() {
        this.getTotalWorkspaces();   
    }
 
};
</script>